module.exports = __webpack_public_path__ + "img/chinesecompany184.ef036c3f.png";